import React, { useState } from "react";
import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ClinicLogo from "../../Assets/logo.png";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ExpandLess from "@mui/icons-material/ExpandLess";
import { Collapse } from "@mui/material";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import AppNavbar from "../AdminUser/AppNavbar";
import HomeRepairServiceIcon from "@mui/icons-material/HomeRepairService";
import AddIcon from '@mui/icons-material/Add';
import { getDecryptedUserType } from "../../Services/LoginUserDetails.js/LoginUserSavedDetails";
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

export default function ReferralUserSidebar() {
  const [state, setState] = useState({ top: false });
  const [openLogoutDialog, setOpenLogoutDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const isLargeScreen = useMediaQuery("(min-width:1441px)");
  const location = useLocation();
  const navigate = useNavigate();
  const LoginUserType = getDecryptedUserType();
  const [openSection, setOpenSection] = useState(null);

  /* ===========================
     FETCH USER FROM SESSION
     =========================== */
  const storedUser = JSON.parse(sessionStorage.getItem("user")) || {};
  const name = storedUser.name || "";
  const fullName = `${name}`;

  const toggleDrawer = (anchor, open) => () => {
    setState({ ...state, [anchor]: open });
  };

  const handleLogoutConfirm = () => {
    setLoading(true);
    setTimeout(() => {
      sessionStorage.clear();
      setLoading(false);
      setOpenLogoutDialog(false);
      navigate("/referal-login");
    }, 1500);
  };

  const list = (anchor) => (
    <Box
      sx={{
        width: 250,
        background: "#094C9F",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        borderTopRightRadius: isLargeScreen ? 30 : 0,
        borderBottomRightRadius: 30,
      }}
    >
      {/* LOGO */}
      <Box sx={{ textAlign: "center", py: 2 }}>
        <img src={ClinicLogo} alt="Logo" style={{ height: 60 }} />
      </Box>

      <Divider />

      {/* MAIN MENU */}
      <List sx={{ flexGrow: 1 }}>
        {[
          { text: "Add Referral", icon: <AddIcon />, path: "/referral/add-referral" },
          { text: "My Referral", icon: <FormatListBulletedIcon />, path: "/referral/my-referral" },
        ].map((item) => (
          <ListItem
            key={item.text}
            disablePadding
            sx={{
              backgroundColor:
                location.pathname === item.path ? "rgba(255,255,255,0.3)" : "inherit",
            }}
          >
            <ListItemButton component={Link} to={item.path} sx={{ color: "white" }}>
              <ListItemIcon sx={{ color: "white" }}>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}

        {/* ADMIN SECTION */}
        {LoginUserType === "admin" && (
          <>
            <ListItemButton
              onClick={() => setOpenSection(openSection === "admin" ? null : "admin")}
              sx={{ color: "white" }}
            >
              <ListItemIcon sx={{ color: "white" }}>
                <AdminPanelSettingsIcon />
              </ListItemIcon>
              <ListItemText primary="Admin" />
              {openSection === "admin" ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse in={openSection === "admin"} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton sx={{ pl: 4, color: "white" }}>
                  <ListItemText primary="Admin Dashboard" />
                </ListItemButton>
              </List>
            </Collapse>
          </>
        )}
      </List>

      {/* ===========================
         PROFILE SECTION (NEW)
         =========================== */}
      {fullName && (
        <>
          <Divider />
          <ListItem disablePadding>
            <ListItemButton
              onClick={() => navigate("/referral/my-profile")}
              sx={{ color: "white", py: 1.5 }}
            >
              <ListItemIcon sx={{ color: "white" }}>
                <AccountCircleIcon fontSize="large" />
              </ListItemIcon>
              <ListItemText
                primary={fullName}
                secondary="My Profile"
                secondaryTypographyProps={{ color: "rgba(255,255,255,0.7)" }}
              />
            </ListItemButton>
          </ListItem>
        </>
      )}

      {/* LOGOUT */}
      <Divider />
      <ListItem disablePadding>
        <ListItemButton onClick={() => setOpenLogoutDialog(true)}>
          <ListItemIcon>
            <PowerSettingsNewIcon sx={{ color: "red" }} />
          </ListItemIcon>
          <ListItemText primary="Logout" sx={{ color: "white" }} />
        </ListItemButton>
      </ListItem>
    </Box>
  );

  return (
    <>
      {!isLargeScreen && <AppNavbar toggleDrawer={toggleDrawer} />}

      {isLargeScreen ? (
        <Drawer variant="permanent" anchor="left" open>
          {list("left")}
        </Drawer>
      ) : (
        <SwipeableDrawer
          anchor="top"
          open={state.top}
          onClose={toggleDrawer("top", false)}
          onOpen={toggleDrawer("top", true)}
        >
          {list("top")}
        </SwipeableDrawer>
      )}

      {/* LOGOUT DIALOG */}
      <Dialog open={openLogoutDialog} onClose={() => setOpenLogoutDialog(false)}>
        <DialogTitle>Logout</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to logout?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenLogoutDialog(false)}>Cancel</Button>
          <Button onClick={handleLogoutConfirm} color="error">
            {loading ? <CircularProgress size={22} /> : "Logout"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
